import { rusPassportCode } from '../constants/constants';
export const parseDocumentNumber = ({ documentNumber, documentType, }) => {
    if (!documentNumber) {
        return {
            number: undefined,
            series: undefined,
        };
    }
    const rusForeignPassportCode = '22';
    const [first, ...rest] = documentNumber.split(/\s+/g);
    const separator = documentType === rusPassportCode || documentType === rusForeignPassportCode ? '' : ' ';
    return rest.length > 0 ? { series: first, number: rest.join(separator) } : { number: first };
};
